import React from 'react';
import { motion } from 'framer-motion';
interface ScaleSelectorProps {
  onSelect: (value: number) => void;
  selectedValue?: number;
}
export function ScaleSelector({
  onSelect,
  selectedValue
}: ScaleSelectorProps) {
  return <div className="w-full flex flex-col gap-3" data-id="element-104">
      <div className="flex justify-between gap-2" data-id="element-105">
        {[1, 2, 3, 4, 5].map((num, i) => {
        const isSelected = selectedValue === num;
        return <motion.button key={num} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} whileTap={{
          scale: 0.9
        }} onClick={() => onSelect(num)} className={`flex-1 aspect-square rounded-2xl flex items-center justify-center text-2xl font-display font-bold transition-all duration-300 border relative overflow-hidden
                ${isSelected ? 'bg-minerva-blue border-minerva-blue text-white shadow-[0_8px_24px_-6px_rgba(0,133,189,0.5)]' : 'bg-white/85 backdrop-blur-md border-slate-200 text-slate-700 hover:bg-white hover:border-minerva-blue/40'}`} data-id="element-106">
              <span className="relative z-10" data-id="element-107">{num}</span>
            </motion.button>;
      })}
      </div>
      <div className="flex justify-between text-[10px] font-semibold text-slate-500 px-1 uppercase tracking-widest" data-id="element-108">
        <span data-id="element-109">Weak</span>
        <span data-id="element-110">Strong</span>
      </div>
    </div>;
}